export default [
  {
    content: "현장의 계기 및 제어기기를 식별하기 위해 기기마다 각각 번호판(Tag No.)을 부착하였는가?",
    isChecked: "",
  },
  {
    content: "근로자가 쉽게 알아볼 수 있도록 계측기기가 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "현장에 설치된 기계식 계기 및 판넬 계기의 지침 디스플레이 화면에는 측정치가 정확하게 표시되고 있는가?",
    isChecked: "",
  },
  {
    content: "현장에 설치된 기계식 계기, 전자식 센서·전송기, 판넬 등은 외관상 열화 변형 또는 파손 없이 정상 상태를 유지하고 있는가?",
    isChecked: "",
  },
  {
    content: "계장용 튜빙(Tubing)은 휘어지거나 처진 부분이 없이 적절히 지지되어있는가?",
    isChecked: "",
  },
  {
    content: "기동·정지 스위치의 Start/stop 표지, 색상 및 배열 순서가 모두 동일하게 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "진공운전 반응기, 증류탑 및 펌프의 흡입구 처럼 음압이 생길 수 있는 곳에는 필요시 연성계(진공압 측정계)를 설치하는가?",
    isChecked: "",
  },
  {
    content: "부식성이나 독성이 있는 유체를 취급하는 설비에 격막식(다이어프램) 압력계를 설치하였는가?",
    isChecked: "",
  },
  {
    content: "압축가스 등 고압 유체를 측정하는 압력계에 벤트 구멍이 설치되어 있으며, 캡 또는 플러그로 막음이 되어 있는가?",
    isChecked: "",
  },
  {
    content: "유리관식 액위계의 유리에 크랙이 있거나 측정 유체가 달라붙어 육안 측정에 어려움이 있지 않은가?",
    isChecked: "",
  },
  {
    content: "폭발 위험장소에는 전기식 또는 전자식 계기, 센서, 전송기(Transmitter), 분석기(Analyzer), 판넬, 접합박스(Junction box) 등을 방폭형으로 설치 하였는가?",
    isChecked: "",
  },
  {
    content: "계기나 센서의 접속부는 부착된 설비 및 배관과 동일한 강도의 플랜지 또는 나사 이음으로 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "계기 또는 센서의 접속부에서 누설이 발생하거나 누설된 흔적이 발견되지않는가?",
    isChecked: "",
  },
  {
    content: "제어밸브(Control valve)의 구동용 공기압력은 적정하며, 밸브 본체에 각인된 화살표는 유체 흐름 방향과일치하는가?",
    isChecked: "",
  },
  {
    content: "접합박스(Junction box)나 계기 외함에서 여분의 접속구에 전용 플러그를 모두 부착하여 구멍 막음 조치를 하였는가?",
    isChecked: "",
  },
  {
    content: "접합박스(Junction box)나 개기 외함에 정전기 방지를 위한 등전위 접지 또는 본딩을 실시하였는가?",
    isChecked: "",
  },
  {
    content: "계기 또는 제어기기 점검 및 유지보수를 위해 진입 계단 및 작업발판이 설치되어 있고, 그 측면에 안전난간대를 설치하였는가?",
    isChecked: "",
  },
  {
    content: "계기 또는 제어기기 기기 접속부에서 화학설비 또는 배관에서 스팀, 고온의 공정 유체 및 부식성 물질 등 유해·위험물질이 새어나와 근로자가 상해를 입을 수 있다는 것을 알고 있으며, 점검 및 정비 작업 시 보안경, 보호장갑 등 보호구를 착용하는가?",
    isChecked: "",
  },
];
